const initialState = {
  projectSystemDefinition: {
    updateControls: {
      progress: false,
      error: null,
    },
  },
};

export default function projectSystemDefinition(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    // GET PROJECTS
    case 'PROJECT_SYSTEM_DEFINITION_UPDATE_CONTROLS_REQUEST':
      return {
        ...state,
        projectSystemDefinition: {
          ...state.projectSystemDefinition,
          updateControls: {
            ...state.projectSystemDefinition.update,
            error: null,
            progress: true,
          },
        },
      };

    case 'PROJECT_SYSTEM_DEFINITION_UPDATE_CONTROLS_FAILURE':
      return {
        ...state,
        projectSystemDefinition: {
          ...state.projectSystemDefinition,
          updateControls: {
            ...state.projectSystemDefinition.update,
            error: payload,
            progress: false,
          },
        },
      };

    case 'PROJECT_SYSTEM_DEFINITION_UPDATE_CONTROLS_SUCCESS':
      return {
        ...state,
        projectSystemDefinition: {
          ...state.projectSystemDefinition,
          updateControls: {
            ...state.projectSystemDefinition.update,
            error: null,
            progress: false,
          },
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/project-system.js